import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "../lib/data";
import { TID } from "../lib/testIds";
import CallToActionStrip from "../components/CallToActionStrip";
import { useSEO } from "../lib/useSEO";
import { buildBreadcrumbs } from "../lib/breadcrumbs";

export default function Services() {
  useSEO({
    title: "Appliance Repair Services in Chicago — Act Fast Appliance Repair",
    description:
      "Refrigerator, washer, dryer, dishwasher, oven and garbage disposal repair across Chicagoland. Factory-trained on 50+ brands. Same-day service. Full parts & labor warranty.",
    path: "/services",
    jsonLd: buildBreadcrumbs([
      { name: "Home", path: "/" },
      { name: "Services", path: "/services" },
    ]),
  });
  return (
    <div className="bg-black">
      <section className="relative pt-32 pb-12 lg:pt-44 lg:pb-20 border-b border-[#262626]">
        <div className="absolute inset-0 af-grid-noise opacity-40" />
        <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
          <p className="af-eyebrow mb-4">Our Repair Services</p>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-extrabold font-display leading-[0.95] mb-6">
            EVERY MAJOR APPLIANCE. <br />
            <span className="text-[#DC2626]">ONE TRUSTED REPAIRMAN.</span>
          </h1>
          <p className="text-lg text-neutral-300 max-w-2xl leading-relaxed">
            From Sub-Zero refrigerators to InSinkErator disposers — Act Fast technicians are factory-trained
            on the full lineup with parts on the truck and a full parts & labor warranty on every repair.
          </p>
        </div>
      </section>

      <section className="py-20 lg:py-28">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="af-card p-8 group flex flex-col"
                data-testid={TID.serviceCard(s.slug)}
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-14 h-14 flex items-center justify-center bg-[#141414] border border-[#262626] group-hover:bg-[#DC2626] group-hover:border-[#DC2626] transition-colors">
                    <Icon size={28} className="text-[#DC2626] group-hover:text-white transition-colors" />
                  </div>
                  <ArrowRight size={20} className="text-neutral-600 group-hover:text-[#DC2626] group-hover:translate-x-1 transition-all" />
                </div>
                <h3 className="text-2xl font-bold font-display mb-3">{s.short}</h3>
                <p className="text-sm text-neutral-400 mb-5 leading-relaxed">{s.description}</p>
                <div className="flex flex-wrap gap-1.5 mt-auto pt-4 border-t border-[#262626]">
                  {s.brands.slice(0, 6).map((b) => (
                    <span key={b} className="af-pill">{b}</span>
                  ))}
                </div>
              </Link>
            );
          })}
        </div>
      </section>

      <CallToActionStrip />
    </div>
  );
}
